import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OptInService } from '../../../services/opt-in.service';
import { ApiEffects } from '../../../utils/effects.util';
import { getOptInActions } from './opt-in.actions';
import { selectOptIn } from './opt-in.selectors';

@Injectable()
export class OptInEffects extends ApiEffects {
  constructor(
    private readonly store: Store,
    protected readonly actions$: Actions,
    private readonly optInService: OptInService
  ) {
    super(actions$);
  }

  getOtpIn$ = this.createCachedApiEffect({
    actions: getOptInActions,
    effectFn: () => this.optInService.getOptIn(),
    cachedObservable: this.store.select(selectOptIn),
  });
}
